// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { string, number, boolean } from "@altostra/type-validations/lib/primitives";

export const isAppsMultiLanguageSettingsGetLocalesResult = objectOf({
  locales: arrayOf(
    objectOf({
      id: string,
      api_identifier: maybe(string),
      name: string,
      country: maybe(string),
      language: maybe(string),
      ca_primary_name: maybe(string),
      ca_primary_value: maybe(string),
      ca_secondary_name: maybe(string),
      ca_secondary_value: maybe(string),
      locale_key: string,
      created_at: maybe(number),
      marked_as_deleted: maybe(boolean),
      a11y_lang: maybe(string),
    })
  ),
});
